<nav  class="scrollable-container navbar navbar-vertical navbar-expand-md navbar-light d-none d-md-block" id="sidenav-main" *ngIf="!isSearch && isVisible" appScrollVisibility>
    <mat-tree class="navbar-nav mb-md-3" [dataSource]="menuOptions" [treeControl]="treeControl" #tree>
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="w-100">
                <a mat-button [routerLink]="['/admin/'+node.ruta]" class="nav-link w-100" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <div class="d-flex align-items-center">
                        <mat-icon class="ml-2 mr-2" *ngIf="node.icono != null && node.icono != ''">{{node.icono}}
                        </mat-icon>
                        <span>{{node.descripcion_opcion|slice:0:25}}</span>
                    </div>
                </a>
            </li>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasRutas">
            <li>
                <div class="mat-tree-node">
                    <button mat-button matTreeNodeToggle class="nav-link w-100 d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <mat-icon class="ml-2 mr-2" *ngIf="node.icono != null && node.icono != ''">{{node.icono}}
                            </mat-icon>
                            <span>{{node.descripcion_opcion|slice:0:25}}</span>
                            <mat-icon>
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </div>
                    </button>
                </div>
                <ul [hidden]="!treeControl.isExpanded(node)" class="list-unstyled pl-3">
                    <ng-container matTreeNodeOutlet></ng-container>
                    <hr class="m-0">
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
</nav>

<div class="container" id="sidenav-main" *ngIf="isSearch">
    <mat-tree class="navbar-nav mb-md-3" [dataSource]="menuOptions" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="w-100">
                <a mat-button [routerLink]="['/admin/'+node.ruta]" class="nav-link w-100" routerLinkActive="active">
                    <div class="d-flex align-items-center">
                        <mat-icon class="ml-2 mr-2" *ngIf="node.icono != null && node.icono != ''">{{node.icono}}
                        </mat-icon>
                        <span>{{node.descripcion_opcion|slice:0:18}}</span>
                    </div>
                </a>
            </li>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasRutas">
            <li>
                <div class="mat-tree-node">
                    <button mat-button matTreeNodeToggle class="nav-link w-100 d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <mat-icon class="ml-2 mr-2" *ngIf="node.icono != null && node.icono != ''">{{node.icono}}
                            </mat-icon>
                            <span>{{node.descripcion_opcion|slice:0:18}}</span>
                            <mat-icon>
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </div>
                    </button>
                </div>
                <ul [hidden]="!treeControl.isExpanded(node)" class="list-unstyled pl-3">
                    <ng-container matTreeNodeOutlet></ng-container>
                    <hr class="m-0">
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>

    <app-footer></app-footer>

</div>